LOGIN: {{ isFirstLogin() }}
<header class="header">
  <app-header
    class="w-full"
    [homePageUrl]="homePageUrl()"
    [isMobile]="isMobile()"
    [firstLogin]="isFirstLogin()"
    [isApplicationContextSelectView]="isApplicationContextSelectView()"
    (toogleSidebar)="toggleSidebar()"
    [sidebarVisible]="sidebarVisible()"
  ></app-header>
</header>
@if (isFirstLogin()) {
  <main class="main-content first-login">
    <div class="layout-wrapper">
      <aside
        class="sidebar"
        [class.-translate-x-full]="!sidebarVisible()"
        [class.translate-x-0]="sidebarVisible()"
      >
        <app-sidebar
          (closeSidebar)="toggleSidebar()"
          [isMobile]="isMobile()"
        ></app-sidebar>
      </aside>

      <div class="main-content first-login">
        <main class="router-outlet-padding">
          <router-outlet></router-outlet>
        </main>
        <footer class="footer">
          <hr class="custom-hr" />
          <app-footer></app-footer>
        </footer>
      </div>
    </div>
  </main>
} @else {
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  <footer class="footer">
    <hr class="custom-hr" />
    <app-footer></app-footer>
  </footer>
}
<app-spinner></app-spinner>
